"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react');
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

// Server records are only partly described here.




































 const timespanOptions = [
  { value: "month", label: "Last 30 days" },
  { value: "quarter", label: "Last 3 months" },
  { value: "year", label: "Last 12 months" },
  { value: "ever", label: "All time" },
]; exports.timespanOptions = timespanOptions

 const calcStartedAfter = (timespanOption) => {
  const timespanLimits = {
    'month': _moment2.default.call(void 0, ).subtract(30, 'days').format(),
    'quarter': _moment2.default.call(void 0, ).subtract(3, 'months').format(),
    'year': _moment2.default.call(void 0, ).subtract(12, 'months').format(),
  }

  return timespanLimits[timespanOption] || null
}; exports.calcStartedAfter = calcStartedAfter

const padDuration = (x) => x.toString().padStart(2, '0')

 const formatTimingLabels = (
  rawStartedAt,
  rawEndedAt,
) => {
  const startedAt = rawStartedAt
    ? _moment2.default.call(void 0, rawStartedAt).calendar()
    : null
  const durationValue = rawStartedAt && rawEndedAt
    ? _moment2.default.duration(_moment2.default.call(void 0, rawEndedAt).diff(rawStartedAt))
    : null
  const duration = durationValue
    ? `${padDuration(durationValue.hours())}:${padDuration(durationValue.minutes())}:${padDuration(durationValue.seconds())}`
    : null

  return {
    startedAt: startedAt || 'N/A',
    duration: duration || 'N/A',
  }
}; exports.formatTimingLabels = formatTimingLabels

// Class-component state for the converted session lists, which chain loads
// through setState callbacks:
// - `setState` merges a partial update, like the class setState;
// - its callback runs after that update commits (componentDidUpdate timing),
//   and every update renders, so the callback always runs (callbacks are
//   flushed at the component's next commit, which is the one that applies
//   their update: these lists only update from events and resolved loads,
//   and the app does not use StrictMode);
// - `latest` holds the committed state, which is what `this.state` read in
//   handlers and callbacks.
 const useClassState = (initialState) => {
  const [state, setFullState] = _react.useState.call(void 0, initialState)
  const latest = _react.useRef.call(void 0, state)
  const pendingCallbacks = _react.useRef([])

  _react.useLayoutEffect.call(void 0, () => {
    latest.current = state
    pendingCallbacks.current.splice(0).forEach(cb => cb())
  })

  const setState = _react.useCallback.call(void 0, (update, callback) => {
    if (callback) pendingCallbacks.current.push(callback)
    setFullState(prev => ({ ...prev, ...update }))
  }, [])

  return [state, setState, latest] 
}; exports.useClassState = useClassState
